import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'
import { XCircle, ArrowRight, Sparkles, LayoutDashboard } from 'lucide-react'

const BillingCancel = () => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-center py-12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className="max-w-md w-full rounded-lg border border-slate-200 bg-white shadow-sm p-8 text-center"
      >
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, type: 'spring', stiffness: 200, damping: 16 }}
          className="w-16 h-16 rounded-lg bg-slate-100 flex items-center justify-center mx-auto mb-5"
        >
          <XCircle className="h-9 w-9 text-slate-500" />
        </motion.div>

        <h1 className="text-xl font-semibold text-slate-900 mb-2">Checkout canceled</h1>
        <p className="text-sm text-slate-500 leading-relaxed">
          No changes were made and you haven't been charged. You can pick a plan whenever you're ready.
        </p>

        <div className="mt-7 flex flex-col gap-2.5">
          <Button
            onClick={() => navigate('/billing')}
            className="rounded-xl gap-1.5 bg-fitness-primary hover:bg-fitness-primary/90 text-primary-foreground"
          >
            <Sparkles className="h-4 w-4" />
            View Plans
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="rounded-xl gap-1.5"
          >
            <LayoutDashboard className="h-4 w-4" />
            Go to Dashboard
          </Button>
        </div>
      </motion.div>
    </div>
  )
}

export default BillingCancel
